function orderItems<T>(array: T[]): T[] {
  const { itemsWithOrder, itemsWithoutOrder } = array.reduce(
    (acc, item: any) => {
      if (item?.order) {
        acc.itemsWithOrder.push(item);
      } else {
        acc.itemsWithoutOrder.push(item);
      }
      return acc;
    },
    { itemsWithOrder: [] as T[], itemsWithoutOrder: [] as T[] }
  );

  const finalOrderedItems: T[] = [...itemsWithoutOrder];

  itemsWithOrder
    .sort((a: any, b: any) => a.order - b.order)
    .forEach((item: any) => {
      finalOrderedItems.splice(item.order - 1, 0, item);
    });

  return finalOrderedItems;
}

export default orderItems;
